export default __webpack_public_path__ + "static/media/highlight.9fc7da4b.png";